module.exports = {"common":"common"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/en.json
// module id = TKku
// module chunks = 1